import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const HeartStateFalseIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "HeartStateFalseIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M11.9917 21C11.3227 21 10.6571 20.7926 10.089 20.3799L3.88608 15.6299C2.71401 14.777 2 13.3529 2 11.8374V8.9485C2 7.26316 2.80406 5.61238 4.20612 4.42004C5.10708 3.6536 6.19594 3.17586 7.35333 3.03965C7.53733 3.01424 8.00861 3 8.03601 3C9.50611 3 10.9111 3.55805 12 4.53897C13.0889 3.55806 14.4939 3 15.964 3C15.9914 3 16.4622 3.01423 16.6697 3.0427C17.8011 3.17383 18.8905 3.65157 19.7944 4.42004C19.7948 4.42004 19.7948 4.42106 19.7948 4.42106C21.1964 5.61441 22 7.26316 22 8.94443V11.8374C22 13.3529 21.2855 14.777 20.0895 15.6472L13.935 20.3616C13.3478 20.7886 12.668 21 11.9917 21ZM8.03601 5.49853C8.01155 5.49853 7.76637 5.50361 7.64744 5.51886C6.92756 5.60424 6.27277 5.89089 5.73054 6.35238C4.88832 7.06901 4.40578 8.01536 4.40578 8.94849V11.8374C4.40578 12.5387 4.73611 13.1984 5.29009 13.602L11.4925 18.351C11.7856 18.5645 12.2138 18.5624 12.5319 18.3327L18.6854 13.6193C19.2634 13.1984 19.5942 12.5387 19.5942 11.8374V8.94442C19.5942 8.01434 19.1117 7.07002 18.2699 6.35238C17.7262 5.88987 17.0709 5.60322 16.3755 5.52191C16.2321 5.50361 15.9884 5.49853 15.9498 5.49853C14.7806 5.49853 13.6663 6.09928 12.9836 7.10661C12.5324 7.77139 11.4675 7.77139 11.0163 7.10661C10.3337 6.09928 9.21933 5.49853 8.03601 5.49853Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default HeartStateFalseIcon;
